<button
  class="p-button-secondary p-button-outlined no-outline text-2xl align-self-end"
  style="margin-left: auto; border: none"
  type="button"
  pButton
  label=""
  icon="pi pi-paperclip"
  tooltipPosition="top"
  pTooltip="Joindre des fichiers"
  i18n-pTooltip="@@chat_input_file_tooltip"
  (click)="openDialogToAddFiles()"
></button>
